import {
  CashRounding,
  RoundingAlgorithm,
} from "../modules/settings/components/PaymentMethodForm/types";
import PaymentMethod from "./data/model/PaymentMethod";

/*
  Default rounding for cash amounts that predates the introduction of RoundingAlgorithm
  this should be used for legacy code that does not specify an algorithm
*/
export function roundCashNearest05(amount: number | string) {
  return Math.round(Number(amount) * 20) / 20;
}

export function roundCashNearest10(amount: number): number {
  // Rounds to nearest 0.10
  return Math.round(amount * 10) / 10;
}

export function cashRoundingPaymentMethod(
  amount: number | string,
  paymentMethod: PaymentMethod
) {
  const rounding = paymentMethod.handler?.args?.find(
    (arg) => arg.name === "cashRounding"
  )?.value as CashRounding | undefined;

  const algorithm = paymentMethod.handler?.args?.find(
    (arg) => arg.name === "roundingAlgorithm"
  )?.value as RoundingAlgorithm | undefined;

  return cashRounding(amount, rounding, algorithm);
}

export function cashRounding(
  amount: number | string,
  rounding?: CashRounding,
  algorithm: RoundingAlgorithm = RoundingAlgorithm.ROUND_MIDPOINT_DOWN
) {
  const num = Number(amount);
  if (isNaN(num)) throw new Error("Invalid amount");

  // use legacy rounding if no CashRounding is specified
  if (!rounding) {
    return round2Decimal(amount);
  }

  // do nothing if CashRounding is NONE
  if (rounding == CashRounding.NONE) {
    return num;
  }

  if (!rounding) {
    return Math.round(num * 100) / 100; // round2Decimal fallback
  }

  if (rounding === CashRounding.ROUND_TO_05) {
    return roundToNearest(num, 0.05, algorithm);
  } else if (rounding === CashRounding.ROUND_TO_10) {
    return roundToNearest(num, 0.1, algorithm);
  }
  // fallback
  return num;
}

/**
 * Rounds a value to nearest (1/unit). If exactly halfway,
 * rounds according to algorithm.
 */
export function roundToNearest(
  value: number,
  unit: number,
  algorithm: RoundingAlgorithm
): number {
  const factor = 1 / unit;
  const scaled = value * factor;
  const floored = Math.floor(scaled);
  const remainder = scaled - floored;

  if (algorithm === RoundingAlgorithm.ROUND_MIDPOINT_DOWN) {
    if (remainder < 0.5) return floored / factor;
    if (remainder > 0.5) return (floored + 1) / factor;
    // exactly halfway, round down
    return floored / factor;
  }
  if (algorithm === RoundingAlgorithm.ROUND_MIDPOINT_UP) {
    if (remainder < 0.5) return floored / factor;
    // exactly halfway or higher, round up
    return (floored + 1) / factor;
  }
  // fallback to standard Math.round
  return Math.round(scaled) / factor;
}

export function round2Decimal(amount: number | string) {
  return roundNumber(Number(amount), 2);
}

function roundNumber(num: number, scale: number = 2) {
  if (!("" + num).includes("e")) {
    //@ts-ignore
    return +(Math.round(num + "e+" + scale) + "e-" + scale);
  } else {
    var arr = ("" + num).split("e");
    var sig = "";
    if (+arr[1] + scale > 0) {
      sig = "+";
    }

    return +(
      //@ts-ignore
      (Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale)
    );
  }
}
